<template>
  <div class="eventComp_mode_22 eventComp_mode_container" v-show="currThemeObj">
    <div class="tableScrollArea" ref="tableParentDom">
      <multiLevelFold_table
        :currThemeObj="currThemeObj"
        :currCid="currCid"
        :currSid="currSid"
        :tableMode="tableMode"
        :parentWidthPx="parentWidthPx"
        :isScrollFlag="isScrollFlag"
        :variableColWidthVw="variableColWidthVw"
        :tableCellDefaultWidthVw="tableCellDefaultWidthVw"
        :defaultWidthVwNum="defaultWidthVwNum"
        :tableColumnData="tableColumnData"
        :tableGroupIndexArr="tableGroupIndexArr"
        :tableGroupRowBgArr="tableGroupRowBgArr"
        :tableData="tableData"
        :expandKey="expandKey"
        :isExpandAll="isExpandAll"
        @toParentEvent="toParentEventHandler"
        v-show="tableData && tableData.length > 0"
      ></multiLevelFold_table>
    </div>
  </div>
</template>

<script>
// 适用：射击 【混合团体决赛】的本场数据 （普通表格：带组的概念+展开行）
import multiLevelFold_table from '@components/platfromBase/compreSportsMeet/table/multiLevelFold_table.vue'
import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'eventComp_mode_22',
  components: {
    multiLevelFold_table,
  },
  props: {
    currSportsDetail: {
      type: Object,
      default: () => ({}),
    },
    sportsTypeArr: {
      type: Array,
      default: () => {
        return []
      },
    },
    datas: {
      type: Object,
      default: () => ({}),
    },
    tabType: {
      type: String, //确定数据来自于 出场名单'startList'  || 本场数据'localData',
      default: '',
    },
    competitorType: {
      type: String,
      default: '', // A || D || T
    },
  },
  mixins: [cup_base_data_mixin],
  watch: {
    datas: {
      handler(newVal, oldVal) {
        console.debug('mode_22 刷新数据:', newVal, oldVal)
        if (JSON.stringify(newVal) != JSON.stringify(oldVal)) {
          this.init()
        }
      },
      //   immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      isScrollBottom: false,
      tableMode: 'eventComp_mode_22',
      parentWidthPx: 0,
      parentHeightPx: 0,
      isScrollFlag: false,
      isClickFlag: false,
      variableColWidthVw: null,
      tableCellDefaultWidthVw: 6.94,
      expandCellDefaultWidthVw: 5.55,
      defaultWidthVwNum: null,
      tableColumnData: [],
      tableData: null,
      tableTotal: 0,
      expandKey: 'isExpand',
      isExpandAll: false, //只要需要expand属性默认都是展开，这个只是控制显示的高度, 控制整个表格是否显示展开行
      currExpandMode: null,
      tableGroupIndexArr: [],
      tableGroupRowBgArr: ['groupBg_subMain05_row'], // 设置：【金牌争夺赛 | 组1】等等整行合并单元格的背景色
      expandModeNameArr: [
        {
          // 本场数据(射击 混合团体 决赛)
          modeName: 'onlyPlayerInfors', //这个name有用再table组件里面
          defaultInsertCustomColuIndex: 0, //在第0个后插入
          tableCellDefaultWidthVw: 6.94,
          sportsIdArr: ['SHO'],
          isTabType: 'localData',
        },
      ],
    }
  },
  beforeCreate() {},
  // created() {
  //   this.init()
  // },
  mounted() {
    window.addEventListener('resize', () => {
      this.onResizeEvent()
    })
    this.init()
  },
  beforeDestroy() {
    window.removeEventListener('resize', () => {
      this.onResizeEvent()
    })
  },
  methods: {
    async init() {
      this.$nextTick(() => {
        this.onResizeEvent()
        // this.computedModeData({})
        if (this.currSportsDetail && this.currSportsDetail.sportsId) {
          let flag = false
          this.expandModeNameArr.forEach((modeItem) => {
            if (modeItem.eventIdArr) {
              if (
                modeItem.sportsIdArr.includes(this.currSportsDetail.sportsId) &&
                modeItem.eventIdArr.includes(this.currSportsDetail.eventId)
              ) {
                flag = true
                this.currExpandMode = modeItem
              }
            } else {
              if (
                modeItem.sportsIdArr.includes(this.currSportsDetail.sportsId) &&
                !flag
              ) {
                this.currExpandMode = modeItem
              }
            }
          })
        }
        console.debug(this.currExpandMode)

        let data = []
        let groupItem = Object.keys(this.datas.data)
        let tableGroupIndexArr = []
        groupItem.forEach((group) => {
          data.push({
            [this.datas.table_head[0].map_key_arr[0]]: group,
          })
          tableGroupIndexArr.push(data.length - 1)
          data = [].concat(data, this.datas.data[group])
        })
        let datas = {
          data,
          table_head: this.datas.table_head,
        }
        console.debug('tableGroupIndexArr:', tableGroupIndexArr)
        this.tableGroupIndexArr = tableGroupIndexArr

        this.computedModeData(JSON.parse(JSON.stringify(datas)))
      })
    },
    toParentEventHandler(data) {
      console.debug(data)
      if (data && data.eventName === 'isTableAllExpandEvent') {
        this.tableData.forEach((rowData) => {
          rowData.isShowChild = data.data
        })
        this.isExpandAll = data.data
      }
      if (data && data.eventName === 'clickItemRowArrowEvent') {
        let isExpandAll = true
        // 有一个是关闭的，全部就是【关闭】状态
        this.tableData.forEach((rowData) => {
          if (!rowData.isShowChild) {
            isExpandAll = false
          }
        })
        this.isExpandAll = isExpandAll
      }
    },
    onResizeEvent() {
      if (this.$refs.tableParentDom) {
        this.parentWidthPx = this.$refs.tableParentDom.offsetWidth
      } else {
        console.debug('dom 不存在')
      }
    },
    computedModeData(data) {
      console.debug(
        'computedModeData:',
        data,
        this.currExpandMode,
        this.tabType
      )
      if (data && data.data) {
        this.tableTotal = data ? data.length : 0
        const table_headArr = data.table_head
        let defaultInsertCustomColuIndex = this.currExpandMode
          ? this.currExpandMode.defaultInsertCustomColuIndex
          : 1 //自定义的表头列插入在第几个后面（有的展开的运动员是在第二列，有的是第三列，所以需要判断；大多数都是第三列，所以默认为在0、1之后插入，也就是第三列）

        // 表头
        const headColumns = []
        table_headArr.forEach((colums, colIndex) => {
          if (colums && colums.map_key_arr.length > 0) {
            headColumns.push({
              colKey: colums.map_key_arr[0] ? colums.map_key_arr[0] : '',
              colTitle: colums.name ? colums.name : '',
            })
          }
        })

        headColumns.push({
          colKey: 'arrowIcon',
          colTitle: '',
        })
        headColumns.push({
          colKey: 'isExpand',
          colTitle: '',
        })

        const otherColumns = headColumns

        let tableCellDefaultWidthVw = this.currExpandMode
          .tableCellDefaultWidthVw
          ? this.currExpandMode.tableCellDefaultWidthVw
          : this.tableCellDefaultWidthVw

        // let variableColWidthVw = this.currExpandMode.variableColWidthVw
        //   ? this.currExpandMode.variableColWidthVw
        //   : this.variableColWidthVw

        // 本场数据

        if (this.tableColumnData.length == 0) {
          let tableColumnData = []
          let customColumn = null

          customColumn = {
            prop: 'teamLogo-teamName', //fristColumnPropArr.join('-'),
            label: '国家/地区',
            // widthVw: variableColWidthVw, //对应列的宽度，单位vw
            className: 'columnTeamLogoTeamNameClass', //单独定制的头部样式class
            // fixed: 'left', //是否锁定，如果开启不滚动，此字段无效
          }

          for (let i = 0; i < otherColumns.length; i++) {
            const item = otherColumns[i]
            if (['运动员', '姓名', '国家/地区'].includes(item.colTitle)) {
              // 特殊列
              tableColumnData.push(customColumn)
            } else {
              tableColumnData.push({
                prop: item.colKey,
                label: item.colTitle,
                widthVw: ['arrowIcon', 'isExpand'].includes(item.colKey)
                  ? this.expandCellDefaultWidthVw / 2
                  : tableCellDefaultWidthVw, //单独设置 [arrowIcon, isExpand] 的对应列的宽度，单位vw, 宽度为普通的一半
                className: ['arrowIcon', 'isExpand'].includes(item.colKey)
                  ? 'expandTdClassName'
                  : '', //单独定制的头部样式class
                selected: '',
              })
            }
            // if (i == defaultInsertCustomColuIndex) {
            //   tableColumnData.push(customTeamColumn)
            // }
          }
          this.defaultWidthVwNum = tableColumnData.length - 3 //减去这2列[teamLogo-teamName, arrowIcon, isExpand]
          this.tableColumnData = tableColumnData
          console.debug('tableColumnData:', tableColumnData)
        }
        let rowHeightVw = 2.778, //第一行 行高
          childRowHeightVw = 6.94, //第一行的展开行，如果是表格的话，就是展示数据的那一行的行高（一般这个行数是不固定的）
          childRowHeightOtherVw = 0 //0.694是表格最下面的留白

        let childRowBaseHeightVw = 0 //第一行展开行的基础高度（固定的高度）

        this.tableData = data.data
          ? data.data.map((rowData) => {
              let currDataListRowNum = 0 //展开行有多高，取决于(上下半场)data.length个数
              if (
                rowData.row_detail &&
                rowData.row_detail.data &&
                rowData.row_detail.data.length > 0
              ) {
                if (rowData.row_detail.data.length > currDataListRowNum) {
                  currDataListRowNum = rowData.row_detail.data.length
                }
              }
              rowData.arrowIcon = ''
              if (this.isExpandAll) {
                //是否全部展开
                rowData.isShowChild = true
              } else {
                rowData.isShowChild = false
              }

              rowData.row_detail = rowData.row_detail ? rowData.row_detail : {}
              if (
                rowData.row_detail &&
                rowData.row_detail.data &&
                rowData.row_detail.data.length > 0
              ) {
                rowData.isHasDetailData = true
              } else {
                rowData.isShowChild = false //就是全部展开，如果没有子内容，展开无用，所以变为false
                rowData.isHasDetailData = false
              }
              let groupTitleObj = null
              if (this.currSportsDetail.sportsId === 'DIV') {
                if (
                  rowData.row_detail.table_head &&
                  rowData.row_detail.table_head.length > 0
                ) {
                  let table_head = []
                  rowData.row_detail.table_head.forEach(
                    (headItem, headIndex) => {
                      if (headItem.name === '裁判分') {
                        groupTitleObj = {
                          left: (headIndex + 1) * 5.55,
                          width: headItem.map_key_arr.length * 3.47,
                        }
                        headItem.map_key_arr.forEach((keyArr) => {
                          const arr = keyArr.split('_')
                          table_head.push({
                            name: arr[1],
                            map_key_arr: [keyArr],
                            className: 'groupItem',
                          })
                        })
                      } else {
                        table_head.push(headItem)
                      }
                    }
                  )
                  rowData.row_detail.table_head = table_head
                }
                if (this.currExpandMode.modeName === 'expandT_rowPlayers') {
                  rowHeightVw = 2.778 //第一行 行高
                  childRowHeightVw = 6.94 //第一行的展开行，如果是表格的话，就是展示数据的那一行的行高（一般这个行数是不固定的）
                  childRowHeightOtherVw = 0 //0.694是表格最下面的留白

                  childRowBaseHeightVw = 0 //第一行展开行的基础高度（固定的高度）
                } else {
                  rowHeightVw = 2.778 //第一行 行高
                  childRowHeightVw = 1.944 //第一行的展开行，如果是表格的话，就是展示数据的那一行的行高（一般这个行数是不固定的）
                  childRowHeightOtherVw = 0 //0.694是表格最下面的留白

                  childRowBaseHeightVw = 3.332 + 1.944 //第一行展开行的基础高度（固定的高度）
                }
              }

              rowData.isExpand = {
                renderMode: this.currSportsDetail.sportsId,
                tabType: this.tabType,
                expandModeName: this.currExpandMode
                  ? this.currExpandMode.modeName
                  : '',
                defaultInsertCustomColuIndex,
                rowHeightVw,
                currHeightVw:
                  childRowBaseHeightVw +
                  currDataListRowNum * childRowHeightVw +
                  childRowHeightOtherVw,
                list: rowData.row_detail,
                groupTitleObj,
              }
              return rowData
            })
          : []

        // this.$refs.tableParentDom.scrollTo(0, 0)
        console.debug('this.tableData:', this.tableData)
      } else {
        console.debug('暂无数据')
        this.notDataHandler()
      }
    },
    notDataHandler() {
      this.tableTotal = 0
      this.tableData = []
    },
  },
}
</script>

<style lang="scss" scoped>
.eventComp_mode_container {
  padding: 1.388vw 0;
  .tableScrollArea {
    position: relative;
    width: 100%;
  }
}
</style>
